// Generated from SVG to Code Figma Plugin

export const LoginWhite = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg
    width={`${78 / 24}em`}
    height="1em"
    fill="none"
    viewBox="0 0 78 24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M75.3024 20.4082L77.7373 20.4047L77.7232 9.56426H75.3024V17.1604C75.3024 17.5624 73.4503 18.5824 72.2846 18.5824C70.8082 18.5824 70.0902 17.5396 70.0902 15.3961V9.5625H67.6641L67.6693 15.4839C67.6693 19.1336 68.914 20.1466 70.4518 20.589C72.016 21.0384 74.0559 20.3292 75.3006 18.7334V20.4082H75.3024Z"
      fill="currentColor"
    />
    <path d="M51.3806 9.56445H48.9492V20.3978H51.3806V9.56445Z" fill="currentColor" />
    <path
      d="M34.1426 5.94531L39.1037 20.3652H42.0635L47.0264 5.94531H44.4897L40.5836 17.2439L36.6793 5.94531H34.1426Z"
      fill="currentColor"
    />
    <path
      d="M58.5992 9.30252C55.8816 9.30252 53.7539 11.8744 53.7539 15.0378C53.7539 18.3611 55.7429 20.7732 58.5992 20.7732C60.044 20.7732 61.5537 20.0411 62.4473 18.9088L62.593 18.7245V20.3887H65.0262V5.53516H62.593V11.5303C61.3413 10.0802 60.1458 9.30252 58.5992 9.30252ZM62.6018 13.9933V16.207C62.6018 16.8531 61.6134 18.5524 59.3892 18.5524C57.667 18.5524 56.3696 17.0321 56.3696 15.015C56.3696 13.019 57.6968 11.4548 59.3892 11.4548C61.4975 11.4548 62.6018 13.342 62.6018 13.9933Z"
      fill="currentColor"
    />
    <path
      d="M50.1627 7.4368C50.9743 7.4368 51.6321 6.77894 51.6321 5.96743C51.6321 5.15591 50.9743 4.49805 50.1627 4.49805C49.3512 4.49805 48.6934 5.15591 48.6934 5.96743C48.6934 6.77894 49.3512 7.4368 50.1627 7.4368Z"
      fill="currentColor"
    />
    <path
      d="M26.6928 16.4336C27.6724 13.4317 29.6228 7.36983 29.6228 7.36983C30.3689 4.92964 29.0434 1.44316 25.6096 0.307329C21.9844 -0.893453 18.8666 1.65382 18.1398 3.98516C18.1398 3.98516 15.5241 12.3854 14.4093 15.8912C13.8774 17.5624 12.559 20.2993 10.0767 20.2993C8.05432 20.2993 7.01504 18.4016 6.57616 17.271L3.56192 9.2342C3.21257 8.38803 3.57772 6.69921 4.97863 6.19362C6.47434 5.65643 7.43637 6.90812 7.68566 7.57171L8.4458 9.51859H12.0113L10.807 6.3604C9.44119 3.40584 6.54807 1.96631 3.68129 3.02138C1.36048 3.87632 -0.872552 6.80454 0.342275 10.4841L3.45307 18.4858C3.92531 19.6989 5.79144 23.6594 10.0082 23.6594C15.0694 23.6594 16.9689 19.3443 18.0222 15.9333C18.5489 14.2269 21.4385 5.00162 21.4385 5.00162C21.858 3.62352 23.5644 3.22677 24.63 3.57437C25.3814 3.81839 26.7402 4.85591 26.3013 6.46397C26.2188 6.75714 23.9138 14.1813 23.0641 16.4389L26.6928 16.4336Z"
      fill="currentColor"
    />
    <path
      d="M23.0645 16.4389C22.6204 17.6168 21.4951 20.1746 18.9338 19.8183C18.1526 21.5475 17.5048 22.5516 16.5234 23.454C19.7185 24.9672 24.3759 23.4434 26.3369 17.5185C26.4299 17.2394 26.551 16.869 26.6932 16.4336L23.0645 16.4389Z"
      fill="url(#paint0_linear_2210_5444)"
    />
    <path
      d="M8.44531 9.51953L11.4402 17.193C12.3356 16.0396 12.9044 14.1629 13.2748 12.834L12.0108 9.51953H8.44531Z"
      fill="url(#paint1_linear_2210_5444)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_2210_5444"
        gradientUnits="userSpaceOnUse"
        x1="22.394"
        x2="14.8372"
        y1="19.9559"
        y2="22.0259"
      >
        <stop stopColor="currentColor" />
        <stop offset="1" stopColor="currentColor" stopOpacity="0.6" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_2210_5444"
        gradientUnits="userSpaceOnUse"
        x1="10.9983"
        x2="13.4174"
        y1="11.5473"
        y2="18.0317"
      >
        <stop stopColor="currentColor" />
        <stop offset="1" stopColor="currentColor" stopOpacity="0.6" />
      </linearGradient>
    </defs>
  </svg>
);
